export const format = (data: any, format: string): string => format.replace(/\{\$([^}]+)\}/g, (_, x) => data[x]);
